
import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';
import { NewReportOptionsTemplateDirective } from '../../../shared/directives/new-report-options-template.directive';
import { ReportDetailsTemplateDirective } from '../../../shared/directives/report-details-template.directive';
import { ReportDateRangeOptionComponent } from '../../../shared/components/report-date-range-option/report-date-range-option.component';
import { ReportAppliedDateRangeOptionComponent } from '../../../shared/components/report-applied-date-range-option/report-applied-date-range-option.component';
import { ReportUsersOptionComponent } from 'app/shared/components/report-users-option/report-users-option.component';
import { ReportAppliedUsersOptionComponent } from 'app/shared/components/report-applied-users-option/report-applied-users-option.component';
import { ReportUserActivityOptionComponent } from 'app/shared/components/report-user-activity-option/report-user-activity-option.component';
import { ReportAppliedUserActivityOptionComponent } from 'app/shared/components/report-applied-user-activity-option/report-applied-user-activity-option.component';
import { ReportUserTypeOptionComponent } from 'app/shared/components/report-user-type-option/report-user-type-option.component';
import { ReportAppliedUserTypeOptionComponent } from 'app/shared/components/report-applied-user-type-option/report-applied-user-type-option.component';

@Component({
  templateUrl: './capture-admin-user-activities-reports.component.html',
  imports: [
    ReportsComponent,
    NewReportOptionsTemplateDirective,
    FormsModule,
    ReactiveFormsModule,
    ReportDetailsTemplateDirective,
    ReportDateRangeOptionComponent,
    ReportAppliedDateRangeOptionComponent,
    ReportUsersOptionComponent,
    ReportAppliedUsersOptionComponent,
    ReportUserActivityOptionComponent,
    ReportAppliedUserActivityOptionComponent,
    ReportUserTypeOptionComponent,
    ReportAppliedUserTypeOptionComponent,
  ]
})
export class CaptureAdminUserActivityReportsComponent {
  private formBuilder = inject(UntypedFormBuilder);

  reportsUrl = `${environment.captureApi.url}/user_activity_reports`;
  reportsCountUrl = `${environment.captureApi.url}/user_activity_reports/count`;

  filtersForm = this.formBuilder.group({
    userIds: [null],
    createdDate: [null],
    activity: [null],
    userType: [null]
  });

  validateForm() {
    const value = this.filtersForm.value;
    return !!value.userIds || !!value.createdDate || !!value.activity || !!value.userType;
  }
}
